export const GET_NEW_PHOTOS = 'GET_NEW_PHOTOS';
export const SEARCH_PHOTOS = 'SEARCH_PHOTOS';
export const ADD_PHOTOS = 'ADD_PHOTOS';
export const LOADING = 'LOADING';
export const OK = 'OK';
export const CHANGE_FILTER = 'CHANGE_FILTER';
